import React, { useContext, useState, useEffect } from "react";
import { UserContext } from "../contexts/UserContext";
import { CatTagProvider } from "../contexts/CatTagContext";
import { MemoProvider } from "../contexts/MemoContext";
import { AutoCatProvider } from "../contexts/AutoCatContext";
import HeaderNav from "../components/HeaderNav";
import SiderNav from "../components/SiderNav";
import { Route } from "react-router-dom";
import DashIndex from "./dashpages/DashIndex";
import FavIndex from "./dashpages/FavIndex";
import CatIndex from "./dashpages/CatIndex";
import SearchIndex from "./dashpages/SearchIndex";
import TagIndex from "./dashpages/TagIndex";
import MemoIndex from "./dashpages/MemoIndex";
import AnalIndex from "./dashpages/AnalIndex";

const Dashboard = () => {
  const { logout, user } = useContext(UserContext);
  const [userInfo, setUserInfo] = useState({
    uid: -69,
    firstName: "first",
    lastName: "last",
    email: "emailAddress",
  });
  useEffect(() => {
    if (user) {
      setUserInfo(user);
    }
  }, [user]);
  const { uid, email, firstName, lastName } = userInfo;
  return (
    <CatTagProvider>
      <MemoProvider>
        <div className="flex w-screen min-h-screen">
          <SiderNav />
          <div className="w-full">
            <div style={{ height: "11.7vh" }}>
              <HeaderNav
                uid={uid}
                email={email}
                firstName={firstName}
                lastName={lastName}
                logout={logout}
              />
            </div>
            <div style={{ height: "88.3vh" }}>
              <Route exact path="/dashboard" component={DashIndex} />
              <Route exact path="/dashboard/favourite" component={FavIndex} />
              <Route exact path="/dashboard/anal" component={AnalIndex} />
              <Route
                exact
                path="/dashboard/category/:cid"
                component={CatIndex}
              />
              <Route
                exact
                path="/dashboard/search/:search"
                component={SearchIndex}
              />
              <Route exact path="/dashboard/tag/:tid" component={TagIndex} />
              <AutoCatProvider>
                <Route
                  exact
                  path="/dashboard/memo/:mid"
                  component={MemoIndex}
                />
              </AutoCatProvider>
            </div>
          </div>
        </div>
      </MemoProvider>
    </CatTagProvider>
  );
};

export default Dashboard;
